import moment from "moment/moment";

export const timeAgo = (date) => {
    if (!date || !moment(date).isValid()) {
        return "a while";
    }
    return moment.duration(moment().diff(date)).humanize();
}

export const getFilename = (key) => {
    if (key.startsWith(defaultPrefix)) return 'DEFAULT';
    const name = key.split('/')[key.split('/').length - 1].slice(0, -3);
    return `${name.slice(0, 7)}: ${name.slice(8).toUpperCase()}`;
}

export const prefix = 'pay-data';
export const lockPrefix = `${prefix}/locked`;
export const defaultPrefix = `${lockPrefix}/default`;